module.exports = __webpack_public_path__ + "static/media/12_1440.b0092554.jpeg";